export const APP_ICON = '/android-chrome-192x192.png';

export const TERMS_AND_CONDITIONAL_FOR_CLIENT =
  'https://mh-img-eu.s3.eu-west-2.amazonaws.com/docs/MTA_Terms+and+Conditions+for+Clients.pdf';

export const TERMS_AND_CONDITIONAL_FOR_PRACTITIONERS =
  'https://mh-img-eu.s3.eu-west-2.amazonaws.com/docs/MTA_Terms_and_Conditions_for_Practitioners_V2.pdf';
